import { getClassName } from "@pairtreefamily/utils";
import { Colors } from "../../types/colors";
import { ButtonColor } from "../button";
import { LinkTo } from "../linkTo";
import { PricingLandingData } from "../../queries/pricingLandingQuery";

const colorMap = {
  darkblue: "text-darkblue",
  teal: "text-teal",
  green: "text-green",
  lightgreen: "text-lightgreen",
  peach: "text-peach",
  rust: "text-rust",
};

type PricingColor = Extract<
  Colors.Solid,
  "darkblue" | "teal" | "green" | "lightgreen" | "peach" | "rust"
>;

export type ProductsComparisonTableFoot = {
  moduleInfo: Pick<PricingLandingData, "moduleProductsComparison">;
};

export function ProductsComparisonTableFoot(
  props: ProductsComparisonTableFoot,
) {
  const moduleInfo = props.moduleInfo.moduleProductsComparison.moduleInput;

  return (
    <tfoot className="table w-full">
      <tr className="w-full">
        <td
          style={{
            width: `calc(100% / (${(moduleInfo.products?.length ?? 0) + 1})`,
          }}
        ></td>
        {moduleInfo.products?.map((product, index) => (
          <td
            key={product?.product?._id}
            className={getClassName(
              "px-4 text-center",
              (index + 1) % 2 == 0 ? "" : "bg-[#f8f8f8]",
            )}
            style={{
              width: `calc(100% / (${(moduleInfo.products?.length ?? 0) + 2})`,
            }}
          >
            <p
              className={getClassName(
                "text-body-2 mt-6",
                colorMap[product?.product?.color as PricingColor],
              )}
            >
              <strong>{moduleInfo.footer?.line1}</strong>
            </p>
            <p className="text-body-2 mb-4">
              <em>{moduleInfo.footer?.line2}</em>
            </p>
            {moduleInfo.footer?.ctaURL && (
              <div className="my-8 flex">
                <LinkTo.External
                  className="w-full"
                  buttonColor={product?.product?.color as ButtonColor}
                  url={product?.ctaURL}
                  buttonStyle="primary"
                  style="button"
                >
                  {moduleInfo.footer.ctaText}
                </LinkTo.External>
              </div>
            )}
          </td>
        ))}
      </tr>
    </tfoot>
  );
}
